module.exports = __webpack_public_path__ + "static/media/clients-01.800c3c3a.svg";